import { useSignal, signal } from "@preact/signals-react";
import Form from "componentsv2/form/Form";
import { useStore, findRecord2 } from "storev2/formStore";
import { getRequired } from "componentsv2/tools/functions";

async function updateStore({ storeId, record, field, value, args, reloadId }) {
  // console.log("updateStore", storeId, record, field, value, args);
  const { saveForm } = useStore.getState();

  record.store[field.name] = value;
  record.active[field.name] = value;
  const { layout } = record;

  if (field?.withChange) {
    await field.withChange(storeId, record, args?.parentRecord);
  }
  if (field?.dependents) {
    for (const dependent of field.dependents) {
      const fieldDef = layout.fields[dependent];
      if (!fieldDef) continue;
      const newRequired = getRequired(fieldDef, record.store);
      fieldDef._requiredSignal ??= signal(newRequired);
      fieldDef._requiredSignal.value = newRequired;
    }
  }

  if (reloadId) {
    reloadId.value += 1;
  }
  if (args?.autoSave) saveForm(record.model, record.id);
}

function TrytonForm(props) {
  const loading = useSignal(false);
  const reloadId = useSignal(0);
  const record = useStore().findRecord(props.storeId);

  async function reloadForm() {
    const { reload } = useStore.getState();
    // Debe ser condicional el parentRec ?
    await reload(props.storeId);
    reloadId.value += 1;
  }

  console.log("TrytonForm render props ===== ...", reloadId.value);
  return (
    <Form
      {...props}
      record={record}
      update={(opts) => updateStore({ ...opts, reloadId })}
      loading={loading}
      reloadId={reloadId.value}
      reload={reloadForm}
    />
  );
}

export default TrytonForm;
